import { aqsiTaxSummary } from '@krp/resource-aqsi-ui'
import { VatSourceCard } from '@krp/platform-ui'

import { messageOf, noEdit, useReloadOn, type NomenclatureCardProps } from '../platform/vatCardKit'
import { aqsiSourceVm } from './aqsiVatModel'

/** Карточка ставки НДС кабинета AQSI в «Номенклатура → Настройка»: только чтение. */
export function AqsiVatCard({ resource, reloadToken }: NomenclatureCardProps) {
  const result = aqsiTaxSummary.useQuery({ resourceId: resource.id })
  useReloadOn(reloadToken, () => void result.refetch())
  const vm = aqsiSourceVm({
    id: resource.id,
    title: resource.displayName,
    summary: result.data ?? null,
    query: { isLoading: result.isFetching, isError: result.isError, errorMessage: result.error === undefined ? null : messageOf(result.error) },
  })
  return <VatSourceCard vm={vm} actions={noEdit(() => void result.refetch())} />
}
